import {ColumnMapping} from '@therms/react-modules'

export const VehicleColumnMapping: (ColumnMapping & {
  multiSelect?: boolean
  subText?: string
})[] = [
  {
    label: 'Make',
    propKey: 'make',
  },
  {
    label: 'Model',
    propKey: 'model',
  },
  {
    label: 'Type',
    propKey: 'type',
  },
  {
    label: 'Color',
    propKey: 'color',
  },
  {
    label: 'Year',
    propKey: 'year',
    subText: 'Must be a number',
    valueType: 'number',
  },
  {
    label: 'Plate',
    propKey: 'plate',
  },
  {
    label: 'State',
    propKey: 'state',
  },
  {
    label: 'Vin',
    propKey: 'vin',
  },
  {
    allowMultiValue: true,
    label: 'Additional Info',
    propKey: 'additional',
  },
]

export const PersonColumnMapping: (ColumnMapping & {
  multiSelect?: boolean
  subText?: string
})[] = [
  {
    label: 'Name',
    propKey: 'name',
  },
  {
    label: 'Alias / Nickname',
    propKey: 'alias',
  },
  {
    label: 'Race',
    propKey: 'race',
  },
  {
    label: 'Gender',
    propKey: 'gender',
  },
  {
    label: 'Height',
    propKey: 'height',
  },
  {
    label: 'Weight',
    propKey: 'weight',
    subText: 'Must be a number',
    valueType: 'number',
  },
  {
    label: 'Eyes',
    propKey: 'eyes',
  },
  {
    label: 'Hair',
    propKey: 'hair',
  },
  {
    label: 'Age',
    propKey: 'age',
    subText: 'Must be a number',
    valueType: 'number',
  },
  {
    label: 'DoB',
    propKey: 'dob',
  },
  {
    label: 'SSN',
    propKey: 'ss',
  },
  {
    label: 'ID #',
    propKey: 'idNumber',
  },
  {
    label: 'ID State / Authority',
    propKey: 'idAuthority',
  },
  {
    label: 'Address',
    propKey: 'streetAddress',
  },
  {
    label: 'City',
    propKey: 'locality',
  },
  {
    label: 'State',
    propKey: 'region',
  },
  {
    label: 'Phone',
    propKey: 'phone',
  },
  {
    label: 'Email',
    propKey: 'email',
  },
  {
    label: 'Criminal Record #',
    propKey: 'criminalId',
  },
  {
    label: 'Criminal Authority / Agency',
    propKey: 'criminalAuthority',
  },
  {
    allowMultiValue: true,
    label: 'Additional Info',
    propKey: 'additional',
  },
]

export const ItemColumnMapping: ColumnMapping[] = [
  {
    label: 'Name',
    propKey: 'name',
  },
  {
    label: 'Brand',
    propKey: 'brand',
  },
  {
    label: 'Style',
    propKey: 'style',
  },
  {
    label: 'Color',
    propKey: 'color',
  },
  {
    label: 'Size',
    propKey: 'size',
  },
  {
    label: 'Status',
    propKey: 'status',
  },
  {
    allowMultiValue: true,
    label: 'Additional Info',
    propKey: 'additional',
  },
]
